/*
 * Program: DailyLog.jsx
 * Application: DailyLog
 * Option: to List out of Daily Log Information
 * Developer: Chandra Shekhar
 * Date: 07-04-2022
 */
import React, { Component } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import SimpleReactValidator from "simple-react-validator";
import DailyLogService from "../../services/DailyLogService";
import { Row, Col, Modal, Button } from "react-bootstrap";
import Moment from "moment";
import back from "./../../assets/images/back.svg";
import DatePicker from "react-datepicker";
import Select from "react-select";
import UserService from "../../services/UserService";
import { Link } from "react-router-dom";
import PropertyService from "../../services/PropertyService";
import PropertySelection from "../dashboard/PropertySelection";
import exportIcon from "./../../assets/images/export-icon.svg";
import Alerts from "../common/Alerts";

export class DailyLog extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });

    this.state = {
      is_inactive: false,
      tableQueryString: "",
      customQueryString: "",
      exportedQueryString: "",
      exportLoading: false,
      showFilter: global.showFilter,
      input: {},
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      filter_value: "",
      loading: false,
      showSpinner: false,
      total_record: 0,
      addCostPayableAtModal: false,
      created_date: "",
      note: "",
      user_name: "",
      dailyLogTitle: "",
      currentPage: 1,
      records: [],
      user_slug: "",
      userList: [],
      selectedUserList: [],
      created_at: "",
      filter_created_at: "",
      filter_created_on: "",
      dateUserString: "",
      isFilterTrue: false,
      perPage: 0,
      showPropertySelectionModal: false,
      selectedPropertyForAdd: null,
      propertyError: null,
      tabStatusId: 1,
      newStatusList: [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 2 },
      ],
      selectedStatusList: [],
      config: {
        sort: {
          column: "created_at",
          order: "desc",
        },
        key_column: "slug",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: true,
        show_filter: global.show_filter,
        show_pagination: global.show_pagination,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No record found",
          filter: "Search by log",
        },
      },

      extraButtons: [],
      columns: [
        {
          key: "title",
          text: "Title",
          className: "log hand-cursor",
          sortable: true,
          cell: (record) => {
            return record.title ? record.title : "";
          },
        },
        {
          key: "created_at",
          text: "Date Time",
          className: "created_at hand-cursor",
          sortable: true,
          cell: (record) => {
            return Moment(record.created_at).format("DD MMM, YY - hh:mm A");
          },
        },
        {
          key: "property_id",
          text: "Property",
          className: "property_id hand-cursor",
          sortable: true,
          cell: (record) => {
            return record.property_name  ? record.property_name : "";
          },
        },
        {
          key: "created_by",
          text: "Technician",
          className: "created_by hand-cursor",
          sortable: false,
          cell: (record) => {
            return record.full_name ? record.full_name : "";
          },
        },
        // {
        //   key: "note",
        //   text: "Note",
        //   className: "note hand-cursor",
        //   sortable: false,
        //   cell: (record) => {
        //     return record.note ? this.limitTextTo50Words(record.note) : "";
        //     // return note;
        //   },
        // },
      ],
      isFirstLoad: true,
      lastQueryString: "",
      singleScreen: false,
      fistLoad: false,
      date: new Date(), // <-- default to current date
      dateError : null,
      selectedPropertyLog : [],
      isFromCalendar : 0,
      showPastDatedailylogInfoModal: false,
      showAddNewdailylogConfirmModal: false,
    };
    this.openLogDetailModal = this.openLogDetailModal.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.changeHandlerdailylog = this.changeHandlerdailylog.bind(this);
    this.filterToggle = this.filterToggle.bind(this);
    this.resetData = this.resetData.bind(this);
    this.customFilter = this.customFilter.bind(this);
    this.getPropertySlug = this.getPropertySlug.bind(this);
    this.exportPdf = this.exportPdf.bind(this);
  }

  componentDidMount() {
    const savedFilterState = JSON.parse(localStorage.getItem('dailyLogFilterState'));
    const savedFormattedData = JSON.parse(localStorage.getItem('formattedDataDailyLog'));
    if (savedFilterState) {
      this.setState({
        property_slug: savedFilterState.property_slug,
        user_slug: savedFilterState.user_slug,
        filter_created_at: savedFilterState.filter_created_at ? new Date(savedFilterState.filter_created_at) : null,
        filter_created_on: savedFilterState.filter_created_on ? new Date(savedFilterState.filter_created_on) : null,
        selectedProperty: savedFilterState.selectedProperty,
        selectedUserList: savedFilterState.selectedUserList,
        isFilterTrue: true,
        module_search: savedFilterState.module_search,
        is_filter: savedFilterState.is_filter,
        formattedData: savedFormattedData || [],
        tabStatusId: savedFilterState.tab || 1,
      }, () => {
        let start_date = "";
        let end_date = "";
        if (this.state.filter_created_at) {
          start_date = Moment(this.state.filter_created_at).format("YYYY-MM-DD");
        }
        if (this.state.filter_created_on) {
          end_date = Moment(this.state.filter_created_on).format("YYYY-MM-DD");
        }
        let queryString =
          "property_slug=" + (this.state.property_slug ? this.state.property_slug : '') +
          "&user_slug=" + (this.state.user_slug ? this.state.user_slug : '') +
          "&is_filter=1" +
          "&per_page=" +
          "&created_at=" + (start_date ? start_date : '') +
          "&created_on=" + (end_date ? end_date : '') +
          "&tab=" + this.state.tabStatusId || 1;
        this.getData(queryString);
        this.setState({ tableQueryString: "", customQueryString: queryString, savedFilterState: savedFilterState});
      });
    } else {
      this.getData();
    }
  }
  getPropertySlug(property_slug) {
    this.setState({ property_slug: property_slug });
    setTimeout(() => {
      var formattedDataProperty = JSON.parse(localStorage.getItem("formattedDataDailyLog"));
      this.setState({ formattedData: formattedDataProperty });
    }, 1000);
    setTimeout(() => {
      this.getData();
      this.getProperty();
    }, 200);
    this.setState({
      unit_number: "",
      module_search: [],
      is_search: 0,
    });
  }
  limitTextTo50Words(htmlContent) {
    // Parse HTML content to extract text
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    const textContent = doc.body.textContent || "";

    // Limit the text content to 50 characters
    const limit = 50;
    let result = textContent.slice(0, limit);

    // Append "..." if the original content is longer than 50 characters
    if (textContent.length > limit) {
        result += '...';
    }
    return result;
  }
  async getData(queryString = "") {
    this.setState({ showSpinner: true });
    if (this.state.isFirstLoad) {
      this.setState({ loading: true, isFirstLoad: false });
    }
    // let localSelectedProperty = "";
    // if (localStorage.getItem("activePropertyCount") == 1) {
    //   localSelectedProperty = {
    //     label: localStorage.getItem("singlePropertyName"),
    //     value: localStorage.getItem("singlePorpertySlug"),
    //   };
    // } else {
    //   if (localStorage.getItem("outSidePorpertySlug") !== undefined &&
    //     localStorage.getItem("outSidePorpertySlug") !== null &&
    //     localStorage.getItem("outSidePorpertySlug") !== "") {
    //     let propertySlug = localStorage.getItem("outSidePorpertySlug");
    //     let propertyName = localStorage.getItem("selectedPropertyName");
    //     queryString = "property_slug=" + propertySlug;
    //    localSelectedProperty = {
    //       label: propertyName,
    //       value: propertySlug,
    //     };
    //   }
    // }
    let propertySlug = "";
    let propertyName = "";
    let localSelectedProperty = "";
    if (localStorage.getItem("activePropertyCount") == 1) {
      localSelectedProperty = {
        label: localStorage.getItem("singlePropertyName"),
        value: localStorage.getItem("singlePorpertySlug"),
        };
    } else {
      if (this.state.singleScreen === true) {
        localSelectedProperty = this.state.selectedProperty;
          if (queryString == "resetCall") {
            localSelectedProperty = [];
          }
      } else {
        if (localStorage.getItem("outSidePorpertySlug") !== undefined &&
        localStorage.getItem("outSidePorpertySlug") !== null &&
          localStorage.getItem("outSidePorpertySlug") !== "") {
        propertySlug = localStorage.getItem("outSidePorpertySlug");
        propertyName = localStorage.getItem("selectedPropertyName");
        if (this.state.fistLoad === false) {
          queryString = queryString ? `${queryString}&property_slug=${propertySlug}` : `property_slug=${propertySlug}`;
          this.setState({fistLoad:true});
        } else {
          queryString += `&property_slug=${propertySlug}`;
        }
        queryString += `&tab=${this.state.tabStatusId}`;

        var formattedData = JSON.parse(localStorage.getItem("formattedDataDailyLog"));
        if(formattedData && formattedData !== null && formattedData !== undefined) {
          // Define the new property value
          var newPropertyValue = "Property: " + propertyName;

          // Loop through the array and replace the Property value
          formattedData = formattedData.map(item => {
              if (item.startsWith("Property:")) {
                  return newPropertyValue; // Replace Property value
              }
              return item; // Keep other values unchanged
          });

          // Store the updated array back in localStorage
          localStorage.setItem("formattedDataDailyLog", JSON.stringify(formattedData));
        }
         localSelectedProperty = {
          label: propertyName,
          value: propertySlug,
        };
        } else {
          localSelectedProperty = [];
          if (queryString == "resetCall") {
            localSelectedProperty = [];
          }
        }
        console.log("propertyName", propertyName)
        if (propertyName === "") {
              queryString = queryString + "&tab=" + this.state.tabStatusId;
            }
        }
     
    }
    var list = [];
    var totalRecords = 0;
    this.setState({ exportedQueryString : queryString});
    let res = await DailyLogService.getList(queryString);
    if (global.successStatus.includes(res.status)) {
      list = res.data.data ? res.data.data : [];
      totalRecords = res.data.total;
    }
    if (queryString !== "resetCall") {
      this.setState({ showFilter: false });
    }
    
    if (list.length === 0 && this.state.isFromCalendar === 1){
      let selectedPropertySlug = (localStorage.getItem("outSidePorpertySlug") != "" && localStorage.getItem("outSidePorpertySlug") != undefined) ? localStorage.getItem("outSidePorpertySlug") : this.state.property_slug;
      this.setState({ selectedPropertySlug });
      let start_date = Moment(this.state.filter_created_at).format("YYYY-MM-DD");
      const queryString = `property_slug=${selectedPropertySlug}&request_type=1&create_date=${start_date}&isfromdetaillog=1`;
      const responsedailylogexist = await DailyLogService.checkDailyLogExists(queryString);
        this.setState({ popupContentForDetail: responsedailylogexist.data.popupContentForDetail,});
       if ((responsedailylogexist.data.status_id === 1 && responsedailylogexist.data.ispastdailylog === 1 ) || (responsedailylogexist.data.status_id === 2 && responsedailylogexist.data.ispastdailylog === 1 ) || (responsedailylogexist.data.ispopupfordetailpage === 1 &&  responsedailylogexist.data.ispastdailylog === 1)){
        this.setState({showPastDatedailylogInfoModal: true,});
      } else if((responsedailylogexist.data.ispopupfordetailpage === 1 &&  responsedailylogexist.data.ispastdailylog === 0) || (responsedailylogexist.data.status_id === 2 && responsedailylogexist.data.ispastdailylog === 0 && responsedailylogexist.data.popupContentForDetail != '')){
         this.setState({
          showAddNewdailylogConfirmModal: true,
          start_date,     
          confirmNavigation: () => {
            this.addnewdailylog();   
          }
        });
      }
    }

    this.setState({
      loading: false,
      isFilterTrue: false,
      total_record: totalRecords,
      records: list,
      selectedProperty:localSelectedProperty,
      showSpinner: false
    });
  }

  addnewdailylog = async () => {
    try {
      let propertySlug;
      let propertyName;
      propertySlug = localStorage.getItem("singlePorpertySlug") !== '' ? this.state.property_slug || 
             localStorage.getItem("outSidePorpertySlug") || 
             localStorage.getItem("singlePorpertySlug") : '';
      propertyName = localStorage.getItem("selectedPropertyName") !== 'All Properties'  ? localStorage.getItem("selectedPropertyName") : propertyName ;
      if (propertySlug && propertyName) {
        const selectedProperty = {value: propertySlug, label: propertyName ? propertyName : ''};
        this.setState({ selectedPropertyLog: selectedProperty });
      }

      this.unblock && this.unblock();
      this.setState({ showAddNewdailylogConfirmModal: false });
      this.setState({ loading: true, showSpinner: true });
      const selectedDate = new Date(this.state.filter_created_at);
      let start_date = Moment(this.state.filter_created_at).format("YYYY-MM-DD");
      const queryString = `property_slug=${this.state.selectedPropertySlug}&request_type=1&create_date=${start_date}`;
      const response = await DailyLogService.checkDailyLogExists(queryString);
      this.setState({ loading: true, showSpinner: true });
       if (response.data.status_id != 1) {
        this.props.history.push({
            pathname: "/daily-log/add",
            state: {
              selectedProperty: this.state.selectedPropertyLog,
              selectedDate: selectedDate,
              slug: response.data.slug,
              isfromdetailpage: true,
              olddailylogslug: this.state.olddailylogslug
            
            }
        });
       }
     
    } catch (err) {
      console.error("Error creating daily log:", err);
    }
  };

  handleAddDailyLog = async (e) => {
    e.preventDefault();
    try {
      // Get the current property slug (from localStorage or state)
      // Try to get propertySlug and propertyName from filter state in localStorage
      let propertySlug;
      let propertyName;
      const dailyLogFilterState = localStorage.getItem('dailyLogFilterState');
      if (dailyLogFilterState) {
        try {
          const filterState = JSON.parse(dailyLogFilterState);
          if (filterState.selectedProperty && filterState.selectedProperty.value && filterState.selectedProperty.label) {
              propertySlug = filterState.selectedProperty.value;
              propertyName = filterState.selectedProperty.label;
          }
        } catch (e) {
          // ignore parse errors
        }
      }

      propertySlug = localStorage.getItem("singlePorpertySlug") !== '' ? this.state.property_slug || 
             localStorage.getItem("outSidePorpertySlug") || 
             localStorage.getItem("singlePorpertySlug") : '';
      propertyName = localStorage.getItem("selectedPropertyName") !== 'All Properties'  ? localStorage.getItem("selectedPropertyName") : propertyName ;
      //const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : "";  
      //const userSlug = userData ? userData.slug : "";
      if (propertySlug && propertyName) {
        const selectedProperty = {value: propertySlug, label: propertyName ? propertyName : ''};
        this.setState({ selectedPropertyLog: selectedProperty });
      }
      this.setState({ showChecklistModal: true });
      this.getProperty();
      return; 
      

      // if(!propertySlug) {
      //   this.setState({ showChecklistModal: true });
      //   this.getProperty();
      //   return; 
      // }
                   
      /*var queryString = "property_slug="+ propertySlug + "&user_slug=" + userSlug + "&request_type=1";
      // Check if log exists for today
      const response = await DailyLogService.checkDailyLogExists(queryString);
      if (response.data.status_id == 1) {
        // Redirect to existing log detail
        this.props.history.push({
            pathname: `/daily-log/${response.data.slug}`,
            state: { 
              selectedProperty: selectedPropertypop 
            }
          });
        // You might want to show the "Add to Daily Log" popup here
      } else {
        // Redirect to add new log
       this.props.history.push({
            pathname: "/daily-log/add",
            state: { 
              selectedProperty: selectedPropertypop,
              slug: response.data.slug
            }
          });
      }*/
    } catch (error) {
      console.error("Error checking daily log:", error);
      // Fallback - redirect to add new log
      // this.props.history.push("/daily-log/add");
    } finally {
      this.setState({ showSpinner: false });
    }
  };
  closePopUp() {
    this.setState({ showChecklistModal: false, property_slug: '', selectedPropertypop: [] });
  }

  cancelNavigation = () => {
    this.setState({showAddNewdailylogConfirmModal: false,showPastDatedailylogInfoModal: false});
  };

  async handleChangePropertyPerform(value) {
    this.setState({ zoneTab: false, propertyError : null });
    let property_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        property_slug.push(item.value);
      });
    }
    await this.setState({
      selectedPropertypop: value,
      selectedPropertyLog: value,
      property_slug: value.value,
      template_slug: value.value,
      singleScreen:
        localStorage.getItem("outSidePorpertySlug") !== undefined &&
        localStorage.getItem("outSidePorpertySlug") !== null &&
        localStorage.getItem("outSidePorpertySlug") !== ""
          ? true
          : false,
      singleScreenProperty: value.label,
    });
  }
  // Get Users List
  async getUserList(queryString = "") {
    var userList = [];
    var userListData = [];
    let res = await UserService.getUserList(
      "is_dropdown=1" + (queryString ? "&" + queryString : "")
    );
    if (global.successStatus.includes(res.status)) {
      userList = res.data ? res.data : [];
    }

    userList.forEach((item) => {
      if (item.role_id >= global.roleTypeId) {
        userListData.push({
          label: item.full_name + "/" + item.email,
          value: item.slug,
        });
      }
    });
    this.setState({ userList: userListData });
  }

  handlePropertySelection = async () => {  
    // Validate property selection
    if (!this.state.selectedPropertyLog || !this.state.selectedPropertyLog.value) {
      this.setState({ propertyError: "Please select a property" });
      return;
    }
  
    this.setState({ showSpinner: true });
    
    try {
      const propertySlug = this.state.selectedPropertyLog.value;
      const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : "";  
      const userSlug = userData ? userData.slug : "";

      const createDate = this.state.date ? Moment(this.state.date).format("YYYY-MM-DD") : "";

      // Check if log exists for today
      const queryString = `property_slug=${propertySlug}&user_slug=${userSlug}&request_type=1&create_date=${createDate}`;
      const response = await DailyLogService.checkDailyLogExists(queryString);
      if (response.data) {
        if( response.data.status_id  == 1) {
          // Redirect to existing log detail with property data
          this.props.history.push({
            pathname: `/daily-log/${response.data.slug}`,
            state: { 
              selectedProperty: this.state.selectedPropertyLog,
              selectedDate: this.state.date,
            }
          });
        } else {
          this.props.history.push({
            pathname: "/daily-log/add",
            state: { 
              selectedProperty: this.state.selectedPropertyLog,
              slug: response.data.slug,
              selectedDate: this.state.date,
            }
          });
         }
      }
    } catch (error) {
      console.error("Error checking daily log:", error);
      // Fallback - redirect to add new log
      this.props.history.push({
        pathname: "/daily-log/add",
        state: { 
          selectedProperty: this.state.selectedPropertyLog,
          selectedDate: this.state.date,
        }
      });
    } finally {
      this.setState({ 
        showSpinner: false,
        showChecklistModal: false
      });
    }
  };

  customFilter= async () => {
    let start_date = "";
    let end_date = "";
    if (this.state.filter_created_at) {
      start_date = Moment(this.state.filter_created_at).format("YYYY-MM-DD");
    }
    if (this.state.filter_created_on) {
      end_date = Moment(this.state.filter_created_on).format("YYYY-MM-DD");
    }

    let queryString = 
    `property_slug=${this.state.property_slug || ''}&` +
    `created_at=${start_date || ''}&` +
    `created_on=${end_date || ''}&` +
    `user_slug=${this.state.user_slug || ''}&` +
    `per_page=${this.state.perPage || ''}&` +
    `tab=${this.state.tabStatusId || ''}&` +
    `is_filter=1`;
    if (this.state.perPage == this.state.total_record) {
      queryString += `&all_records=all`;
    }

    if (queryString !== "") {
      this.setState({ lastQueryString: queryString });
      this.setState({ isFilterTrue: true });
      this.setState({ is_filter: 1 });
    }
    const filterState = JSON.stringify({
      property_slug: this.state.property_slug,
      user_slug: this.state.user_slug,
      filter_created_at: this.state.filter_created_at,
      filter_created_on: this.state.filter_created_on,
      selectedProperty: this.state.selectedProperty,
      selectedUserList: this.state.selectedUserList,
      is_filter: 1,
      tab: this.state.tabStatusId,
    });
    // Save the filter state to local storage
    localStorage.setItem('dailyLogFilterState', filterState);
    const result1 = JSON.parse(filterState);
    
    const formattedData = [];
    if (result1?.selectedProperty?.label) {
      formattedData.push(`Property: ${result1?.selectedProperty?.label}`);
    } else {
      if (
        (this.state.singleScreenProperty && this.state.singleScreenProperty !== "All Properties") || 
        (localStorage.getItem("selectedPropertyName") && localStorage.getItem("selectedPropertyName") !== "All Properties")
      ) {
        const propertyName = this.state.singleScreenProperty 
          ? this.state.singleScreenProperty 
          : localStorage.getItem("selectedPropertyName");
        formattedData.push(`Property: ${propertyName}`);
      }
    }
    if (result1?.selectedUserList?.label) {
      formattedData.push(`Technician: ${result1?.selectedUserList?.label}`);
    }
    if (result1?.filter_created_at) {
      formattedData.push(`Start Date: ${Moment(result1?.filter_created_at).format("DD MMM, YY")}`);
    }
    if (result1?.filter_created_on) {
      formattedData.push(`End Date: ${Moment(result1?.filter_created_on).format("DD MMM, YY")}`);
    }
    this.setState({ formattedData });
    localStorage.setItem('formattedDataDailyLog', JSON.stringify(formattedData));
    this.getData(queryString);
    if (this.state.showFilter === 1) {
      document.body.classList.remove("bdy_over");
    }
  }

  resetData() {
    this.setState({ is_filter: 0 });
    this.setState({
      filter_created_at: "",
      filter_created_on: "",
      selectedUserList: [],
      user_slug: "",
      date: "",
      lastQueryString: "",
      singleScreenProperty: "",
      singleScreen: false,
      formattedData: [],
      property_slug: "",
    });
    this.setState({ module_search: "" });
    // Clear the filter state from local storage
   localStorage.removeItem('dailyLogFilterState');
   localStorage.removeItem('formattedDataDailyLog');
    this.getData("resetCall");
  }

  filterToggle = () => {
    if (this.state.showFilter === 1) {
      this.setState({ showFilter: 0 });
      document.body.classList.remove("bdy_over");
    } else {
      this.setState({ showFilter: 1 });
      this.getUserList();
      this.getProperty();
      document.body.classList.add("bdy_over");
    }
  };

  closeModal() {
    this.setState({ showAlertModal: false });
  }

  changeHandler = (event) => {
    let input = this.state.input;
    let value = event.target.value;
    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });
    this.validator.showMessageFor(event.target.name);
    this.setState({dateError : null, date : value});
    this.customValidate();
  };

  changeHandlerdailylog = (event) => {
    let input = this.state.input;
    let value = event.target.value;
    input[event.target.name] = value;
    this.setState(
      {
        [event.target.name]: value,
        input: input,
        dateError: null,
        filter_created_at: value,
        isFromCalendar: 1
      },
      () => {
        this.validator.showMessageFor(event.target.name);
        this.customValidate();

        // Call filter AFTER state updates
        this.customFilter();
      }
    );
  };

  handleArrowClick = (direction) => {
  let { filter_created_at } = this.state;

  // Determine current selected date
  const currentDate =
    filter_created_at
      ? new Date(filter_created_at)
      : new Date();

  // Change date by direction (+1 or -1)
  const newDate = new Date(currentDate);
  newDate.setDate(currentDate.getDate() + direction);

  // Update using your existing handler
  this.changeHandlerdailylog({
    target: {
      type: "date",
      name: "filter_created_at",
      value: newDate,
    },
  });
};

  // Technician/User Change Handler
  handleChangeUserList(value) {
    let user_slug = [];
    if (value !== null && value.length > 0) {
      value.forEach((item, i) => {
        user_slug.push(item.value);
      });
    }
    this.setState({
      selectedUserList: value,
      user_slug: value.value,
      user_name: value.label,
    });
  }

  tableChangeHandler = (data) => {
    // Show the spinner when the table change starts
    this.setState({ showSpinner: true });
  
    // Function to create query parameters
    const createQueryParams = (data) => {
      const params = new URLSearchParams();
      Object.keys(data).forEach((key) => {
        if (key === "sort_order" && data[key]) {
          params.append("sort_order", data[key].order);
          params.append("sort_column", data[key].column);
        } else {
          let newKey = key;
          if (key === "page_number") {
            newKey = "page";
          } else if (key === "sort_order") {
              data[key] = "asc";
            } else if (key === "page_size") {
              newKey = "per_page";
              this.setState({ perPage: data[key]});
            }
          params.append(newKey, data[key]);
        }
      });
      if (data.page_size == this.state.total_record) {
        params.append("all_records", "all");
      }
      
      return params.toString();
    };
    
    const pageSize = Number(data.page_size);
    const validPageSizes = [10,20, 50, 100];

    let possible = this.state.total_record / pageSize + (this.state.total_record % pageSize ? 1 : 0);

    if (data.page_number > possible || ( pageSize && !validPageSizes.includes(pageSize))) {
      data.page_number = 1; 
    }
    let queryString = createQueryParams(data);
  
    if (data.filter_value === "") {
      queryString += `&${this.state.customQueryString}`;
    }
  
    this.setState({ tableQueryString: queryString });
  
    if (data.filter_value !== this.state.filter_value) {  
      clearTimeout(this.state.filter_time);
      this.setState({
        filter_time: setTimeout(
          () => {
            this.getData(queryString).finally(() => {
              // Hide the spinner after data is fetched
              this.setState({ showSpinner: false });
            });
          },
          global.filter_time
        ),
        filter_value: data.filter_value,
      });
    } else {
      if (this.state.firstLoad === true) {
        queryString = new URLSearchParams({
          page: data.page_number,
          page_size: data.page_size,
          sort_order: data.sort_order.order,
          sort_column: data.sort_order.column,
        }).toString();
      }
    // Parse the last query string to update parameters
    const updatedParams = new URLSearchParams(this.state.lastQueryString);
    
    // Check if 'per_page' exists in the parameters
    if (updatedParams.has('per_page')) {
        updatedParams.delete('per_page');
        // Update state with modified parameters
        this.setState({ lastQueryString: updatedParams.toString() });
    }
      // Fetch data with the updated query string
      this.getData(`${queryString}${updatedParams.toString()}`).finally(() => {
          // Hide the spinner after data is fetched
          this.setState({ showSpinner: false });
      });
    }
  };
  //get property data
  async getProperty(queryString = "") {
    var propertyList = [];
    var propertyListData = [];
    let res = await PropertyService.getPropertyList(
      "is_dropdown=1" + (queryString ? "&" + queryString : "")
    );
    if (global.successStatus.includes(res.status)) {
      propertyList = res.data ? res.data : [];
    }
    if (propertyList.length > 0) {
      propertyList.forEach((item) => {
        propertyListData.push({
          label: item.property_name,
          value: item.slug,
        });
      });
    }
    this.setState({
      propertyList: propertyListData,
    });
  }
   //property type handle
   handleChangeProperty(value) {
    let property_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        property_slug.push(item.value);
      });
    }
    this.setState({
      selectedProperty: value,
      property_slug: value.value,
      singleScreen: (localStorage.getItem("outSidePorpertySlug") !== undefined &&
      localStorage.getItem("outSidePorpertySlug") !== null &&
        localStorage.getItem("outSidePorpertySlug") !== "" ? true:false),
      singleScreenProperty: value.label,
      property_name1: value.label,
    });
  }
  rowClickedHandler = (event, data, rowIndex) => {
    this.props.history.push("/daily-log/" + data.slug);
  };

  customValidate() {
    let isValid = true;
    return isValid;
  }

  openLogDetailModal(slug, rowIndex) {
    this.getDailyLogDetails(slug, rowIndex);
    this.setState({ addCostPayableAtModal: true });
    this.setState({ slug: slug });
  }

  closeLogDetailAtModal() {
    this.setState({ title: "", dateUserString: "", user_name: "", note: "" });
    this.setState({ addCostPayableAtModal: false });
  }

  async getDailyLogDetails(slug) {
    if (slug) {
      var resData = {};
      let res = await DailyLogService.getDetails(slug);
      if (global.successStatus.includes(res.status)) {
        resData = res.data ? res.data : {};
        let dateUserString =
          Moment(resData.created_at).format("DD MMM, YY - hh:mm A") +
          " . " +
          resData.user.full_name;
        this.setState({
          note: resData.note,
          title: resData.title,
          dateUserString: dateUserString,
        });
      }
      this.setState(resData);
    }
  }
  handleStatusClick(statusId) {
    let sortOrder = "desc";
    this.setState(
      {
        tabStatusId: statusId,
        selectedStatusList: [
          { label: this.getStatusLabel(statusId), value: statusId },
        ],
        isStatusFilter: true,
        sort_order: sortOrder,
        config: {
          ...this.state.config,
          sort: {
            column: "created_at",
            order: sortOrder,
          },
        },
      },
      () => {
        this.customFilter();
      }
    );
  }
  getStatusLabel(statusId) {
    switch (statusId) {
      case 1:
        return "Current & Past Dates";
      case 2:
        return "Future Dates";
      default:
        return "";
    }
  }

  async exportPdf() {
    this.setState({ exportLoading: true });
    let exportResult = await DailyLogService.exportLogs(this.state.exportedQueryString);
    if (global.successStatus.includes(exportResult.status)) {
      this.setState(
        {
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          exportLoading: false,
          alertModalMessage: exportResult.message || "Success",
        },
        () => {
          // Auto-hide after 3 seconds
          setTimeout(() => {
            this.setState({ showAlertModal: false });
          }, 3000);
        }
      );
    } else {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: exportResult?.message,
        exportLoading: false,
      });
    }
  }

  render() {
    const statuses = [
      { id: 1, label: "Current & Past Dates" },
      { id: 2, label: "Future Dates" },
    ];
    const showPastDatedailylogInfoModal = this.state.showPastDatedailylogInfoModal;
    const showAddNewdailylogConfirmModal = this.state.showAddNewdailylogConfirmModal;
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color:
          state.isSelected && state.isFocused
            ? "white"
            : state.isSelected
            ? "black"
            : state.isFocused && "white",
        backgroundColor:
          state.isSelected && state.isFocused
            ? "gray"
            : state.isFocused && "gray",
        fontFamily: "Roboto-Regular",
        fontSize: "16px",
      }),
    };
    return (
      <div>
        <main>
          {this.state.showSpinner && (
            <div className="spinnerLoader1">
              <div className="toploader1">
                <img src={require("../../assets/images/Loader-new.gif").default} alt="Loading" />
              </div>
            </div>
          )}
          <div className="container-fluid">
            <div className="row row-xs">
              <div className="col-md-12">
                <div className="brandSection">
                  <div className="dashbaord-pageHeadertitle heading_alignment">
                    <h3 className="flex-column">
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <h3>Daily Logs</h3>
                        {(localStorage.getItem("outSidePorpertySlug") !== undefined && localStorage.getItem("outSidePorpertySlug") !== null && localStorage.getItem("outSidePorpertySlug") !== "") || (this.state.property_slug != "" && this.state.property_slug != undefined) ? (
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="Collapsible-arrow log-arrow c-gray-color dateleftarrow btn_arrow_header"
                               onClick={() => this.handleArrowClick(-1)}>
                              <i className={`fa fa-angle-left fs-4`}></i>
                            </span>
                            <div className="justify-content-center">
                                <Col
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    className="mb-md-0 mb-3 pb-0 px-2"
                                  >
                                    <DatePicker
                                      className="form-control max_width_100"
                                      wrapperClassName="input_date_wrap"
                                      showMonthDropdown
                                      showYearDropdown
                                      scrollableYearDropdown
                                      autoComplete="off"
                                      yearDropdownItemNumber={
                                        global.yearDropdownItemNumber
                                      }
                                      name="filter_created_at"
                                      placeholderText="dd-mm-yy"
                                      dateFormat="dd MMM yy"
                                      selected={this.state.filter_created_at}
                                       onChange={(data) =>
                                      this.changeHandlerdailylog({
                                        target: {
                                          type: "date",
                                          name: "filter_created_at",
                                          value: data,
                                        },
                                      })
                                    }
                                    maxDate={this.state.filter_created_on}
                                      />
                                </Col>
                            </div>
                            <span className="Collapsible-arrow log-arrow c-gray-color daterightarrow btn_arrow_header"
                             onClick={() => this.handleArrowClick(1)} >
                              <i className={`fa fa-angle-right fs-4`}></i>
                            </span>                          
                          </div>
                        ):''}
                        <div className="btnNavigate d-flex justify-content-end">
                          {global.userPermissions.checkPermission("daily_logs-add") && (
                        <Link to="#" onClick={(e) => this.handleAddDailyLog(e)}>
                        <button className="gf-primary-btn-small-one mg-l-7">
                          Add Daily Log
                        </button>
                      </Link>)}
                      {global.userPermissions.checkPermission("daily_logs-export") && ((this.state.property_slug != "" && this.state.property_slug != undefined) || (localStorage.getItem("singlePorpertySlug") != "" && localStorage.getItem("singlePorpertySlug") != undefined))  && (
                        <Button
                            onClick={this.exportPdf}
                            className="gf-primary-btn-small-one loader_btn pdf_gen export_pdf_btn mg-l-7"
                          >
                            <img src={exportIcon} alt="" />
                            {this.state.exportLoading ? global.loader : "Export PDF"}
                        </Button>
                      )}

                          <button
                            onClick={this.filterToggle}
                            className="gf-primary-btn-small-one mg-l-7"
                          >
                            {" "}
                            {this.state.showFilter === 1 ? "Filter" : "Filter"}
                          </button>
                        </div>
                      </div>
                      <span>All Daily Logs</span>
                    </h3>
                  </div>
                  <div className="col-md-12 pl-0 pr-0">
                    <Alerts
                      show={this.state.showAlertModal}
                      type={this.state.alertModalType}
                      title={this.state.alertModalTitle}
                      message={this.state.alertModalMessage}
                      onClose={() => this.setState({ showAlertModal: false })}
                    />
                  </div>

                  {this.state.showFilter ? (
                    <Row className="align-items-start fliter_back">
                      <div className="order_form">
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <h3
                            className="hand-cursor back-size"
                            onClick={this.filterToggle}
                          >
                            <img src={back} alt="" />
                            Back
                          </h3>
                        </div>
                        <h3>Filter</h3>
                        <Row className="align-items-start justify-content-between m-0 p-0">
                        <Col
                            md={12}
                            lg={12}
                            xl={12}
                            className="mb-md-0 mb-3 pl-0"
                          >
                            <label className="form-label text-left mg-b-5 mt-0">
                              Property{" "}
                            </label>
                            <Select
                              className="multiselect new_drop"
                              menuPlacement="auto"
                              value={this.state.selectedProperty}
                              options={this.state.propertyList}
                              isSearchable={true}
                              onChange={(value) =>
                                this.handleChangeProperty(value)
                              }
                              defaultValue={this.state.selectedStatusList}
                              autoComplete="off"
                              getOptionValue={(option) => `${option.label}`}
                              styles={customStyles}
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary75: "#808080",
                                  primary50: "#808080",
                                  primary25: "#808080",
                                },
                              })}
                            />
                          </Col>
                          <Col
                            md={12}
                            lg={12}
                            xl={12}
                            className="mb-md-0 mb-3 pl-0 pb-0"
                          >
                            <label className="form-label text-left mg-b-5">
                              Start Date{" "}
                            </label>
                            <DatePicker
                              className="form-control max_width_100"
                              showMonthDropdown
                              showYearDropdown
                              scrollableYearDropdown
                              autoComplete="off"
                              yearDropdownItemNumber={
                                global.yearDropdownItemNumber
                              }
                              name="filter_created_at"
                              placeholderText="dd-mm-yy"
                              dateFormat="dd MMM yy"
                              selected={this.state.filter_created_at}
                              onChange={(data) =>
                                this.changeHandler({
                                  target: {
                                    type: "date",
                                    name: "filter_created_at",
                                    value: data,
                                  },
                                })
                              }
                              maxDate={this.state.filter_created_on}
                            />
                          </Col>
                          <Col
                            md={12}
                            lg={12}
                            xl={12}
                            className="mb-md-0 mb-3 pl-0 pb-0"
                          >
                            <label className="form-label text-left mg-b-5">
                              End Date{" "}
                            </label>
                            <DatePicker
                              className="form-control max_width_100"
                              showMonthDropdown
                              showYearDropdown
                              scrollableYearDropdown
                              autoComplete="off"
                              yearDropdownItemNumber={
                                global.yearDropdownItemNumber
                              }
                              name="filter_created_on"
                              placeholderText="dd-mm-yy"
                              dateFormat="dd MMM yy"
                              selected={this.state.filter_created_on}
                              onChange={(data) =>
                                this.changeHandler({
                                  target: {
                                    type: "date",
                                    name: "filter_created_on",
                                    value: data,
                                  },
                                })
                              }
                              minDate={this.state.filter_created_at}
                            />
                          </Col>
                          <Col
                            md={12}
                            lg={12}
                            xl={12}
                            className="mb-md-0 mb-3 pl-0"
                          >
                            <label className="form-label text-left mg-b-5">
                              technician{" "}
                            </label>
                            <Select
                              className="multiselect new_drop"
                              menuPlacement="auto"
                              value={this.state.selectedUserList}
                              options={this.state.userList}
                              onChange={(value) =>
                                this.handleChangeUserList(value)
                              }
                              defaultValue={this.state.selectedUserList}
                              autoComplete="off"
                              getOptionValue={(option) => `${option.label}`}
                              styles={customStyles}
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary75: "#808080",
                                  primary50: "#808080",
                                  primary25: "#808080",
                                },
                              })}
                            />
                          </Col>
                          <Row className="row col-md-12 mg-t-30 justify-content-between w-100 pr-0">
                            <button
                              onClick={this.resetData}
                              className="btn-success-outline"
                            >
                              Reset
                            </button>
                            <button

                                onClick={() => {
                                    this.setState({ isFromCalendar: 0 }, () => {
                                    this.customFilter();
                                  });
                                }}
                                
                              className="btn-success mg-l-0 mg-r-20"
                            >
                              {this.state.isFilterTrue
                                ? global.loader
                                : "Search"}
                            </button>
                          </Row>
                        </Row>
                      </div>
                    </Row>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0">
                <div className="col-md-12">
                  <div className="scrolling-carousel pd-l-0">
                    <div className="status-buttons d-flex justify-content-start mt-3">
                      {statuses.map((status) => (
                        <button
                          key={status.id}
                          type="button"
                          className={`btn ${
                            this.state.tabStatusId === status.id ? "active" : ""
                          }`}
                          onClick={() => this.handleStatusClick(status.id)}
                        >
                          {status.label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="ht-50"></div> */}
            </div>
          </div>
          <div className="container-fluid">
            <div className="brandList dashboardRightcard">
            <PropertySelection
                propertySlug={this.getPropertySlug.bind(this)}
                outSidePropertySlug={this.state.outSidePropertySlug}
              />
              {this.state.formattedData && this.state.formattedData.length > 0 ? (
                <>
                  {/* <div className="col-xxl-12 col-sm-12 pd-lg-r-30 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                    <div className="custm-filter">
                      <div> */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="checklist_table_heading">
                        {" "}
                        <span className="lspan">
                        {(this.state.formattedData && this.state.formattedData.length && this.state.formattedData.join(', ')) ? <> Search Applied On:&nbsp;{" "} </>: ''}
                        </span>
                        <span className="rspan">
                        {(this.state.formattedData && this.state.formattedData.length > 0) ? this.state.formattedData.join(', ') : ''}

                        {(this.state.formattedData && this.state.formattedData.length > 0) && (
                          <a
                            type="button"
                            onClick={this.resetData}
                            className="global-flt-clearBtn"
                          >
                            Clear
                          </a>
                        )}
                          </span>
                      {/* </div> */}
                    </div>
                    </div>
                  </div>
                </>
              ) : (
              ""
            )}
            {localStorage.getItem("outSidePorpertySlug") && (this.state.formattedData == undefined || this.state.formattedData.length == 0) ? (<>
                <div className="row">
                <div className="col-md-12">
                    <div className="checklist_table_heading"><span className="lspan">Search Applied On:&nbsp;</span><span className="rspan">{this.state.singleScreenProperty ? this.state.singleScreenProperty:localStorage.getItem("selectedPropertyName") }</span></div>
                </div>
              </div>
              </>) :""}
              <ReactDatatable
                className="table no-wrap mg-b-30 pd-b-2"
                config={this.state.config}
                records={this.state.records}
                columns={this.state.columns}
                extraButtons={this.state.extraButtons}
                dynamic={true}
                loading={this.state.loading}
                total_record={this.state.total_record}
                onChange={this.tableChangeHandler}
                onRowClicked={this.rowClickedHandler}
              />
            </div>
          </div>
        </main>
        <Modal show={this.state.showChecklistModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span className="welcomeClose" onClick={() => this.closeModal()}>
              {global.closee}
            </span>

            <h3 className="text-center">Daily Log</h3>
            <label>Property</label>
            <Select
                className="multiselect new_drop"
                menuPlacement="auto"
                value={this.state.selectedPropertyLog}
                options={this.state.propertyList}
                isSearchable={true}
                onChange={(value) =>
                  this.handleChangePropertyPerform(value)
                }
                defaultValue={this.state.selectedPropertyLog}
                autoComplete="off"
                getOptionValue={(option) => `${option.label}`}
                styles={customStyles}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary75: "#808080",
                    primary50: "#808080",
                    primary25: "#808080",
                  },
                })}
              />
            {this.state.propertyError && (
              <div className="text-danger">{this.state.propertyError}</div>
            )}

            {global.userPermissions.checkPermission(
                "daily_logs-add-future-logs"
              ) && (
              <div className="mt-3">
                <label className="form-label text-left mg-b-5">
                  Date
                </label>
                <DatePicker
                  className="form-control max_width_100"
                  showMonthDropdown
                  showYearDropdown
                  scrollableYearDropdown
                  autoComplete="off"
                  yearDropdownItemNumber={
                    global.yearDropdownItemNumber
                  }
                  name="date"
                  placeholderText="mm-dd-yy"
                  dateFormat="dd MMM yy"
                  selected={this.state.date}
                  onChange={(data) =>
                    this.changeHandler({
                      target: {
                        type: "date",
                        name: "date",
                        value: data,
                      },
                    })
                  }
                  minDate={Moment().toDate()}
                />
                {this.state.dateError && (
                  <div className="text-danger">{this.state.dateError}</div>
                )}
              </div>
            )}

            <div className="cnt_center d-flex mt-3">
              <button
                type="button"
                className=" m-0 btn btn-outline-light btn-block"
                onClick={() => this.closePopUp("basic")}
              >
                Cancel
              </button>
              <button
                  type="button"
                   className=" m-0 btn btn btn-success btn-block"
                  onClick={() => this.handlePropertySelection()}
                >
                  Continue
                </button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={showPastDatedailylogInfoModal} centered onHide={this.cancelNavigation}>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.popupContentForDetail,
                    }}
                  />
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={this.cancelNavigation}
                >
                  OK
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={showAddNewdailylogConfirmModal} centered onHide={this.cancelNavigation}>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.popupContentForDetail,
                    }}
                  />
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={this.cancelNavigation}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn-danger btn-block"
                  onClick={this.addnewdailylog}
                >
                  Ok
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default DailyLog;
